import api from './api';

const chemicalService = {
  // ─── Dashboard ─────────────────────────────────────────────
  getDashboard: async () => {
    const response = await api.get('/api/chemical/dashboard');
    return response.data;
  },
  getDashboardKpis: async () => {
    const response = await api.get('/api/chemical/dashboard/kpis');
    return response.data;
  },
  getDashboardAlerts: async () => {
    const response = await api.get('/api/chemical/dashboard/alerts');
    return response.data;
  },
  getDashboardRecentActivity: async () => {
    const response = await api.get('/api/chemical/dashboard/recent-activity');
    return response.data;
  },

  // ─── Products ──────────────────────────────────────────────
  getProducts: async (params = {}) => {
    const response = await api.get('/api/chemical/products', { params });
    return response.data;
  },
  getProductsSummary: async () => {
    const response = await api.get('/api/chemical/products/summary');
    return response.data;
  },
  getProductById: async (id) => {
    const response = await api.get(`/api/chemical/products/${id}`);
    return response.data;
  },
  createProduct: async (data) => {
    const response = await api.post('/api/chemical/products', data);
    return response.data;
  },
  updateProduct: async (id, data) => {
    const response = await api.put(`/api/chemical/products/${id}`, data);
    return response.data;
  },
  deleteProduct: async (id) => {
    const response = await api.delete(`/api/chemical/products/${id}`);
    return response.data;
  },

  // ─── Customers ─────────────────────────────────────────────
  getCustomers: async (params = {}) => {
    const response = await api.get('/api/chemical/customers', { params });
    return response.data;
  },
  getCustomersSummary: async () => {
    const response = await api.get('/api/chemical/customers/summary');
    return response.data;
  },
  getCustomerById: async (id) => {
    const response = await api.get(`/api/chemical/customers/${id}`);
    return response.data;
  },
  createCustomer: async (data) => {
    const response = await api.post('/api/chemical/customers', data);
    return response.data;
  },
  updateCustomer: async (id, data) => {
    const response = await api.put(`/api/chemical/customers/${id}`, data);
    return response.data;
  },
  deleteCustomer: async (id) => {
    const response = await api.delete(`/api/chemical/customers/${id}`);
    return response.data;
  },

  // ─── Vendors ───────────────────────────────────────────────
  getVendors: async (params = {}) => {
    const response = await api.get('/api/chemical/vendors', { params });
    return response.data;
  },
  getVendorsSummary: async () => {
    const response = await api.get('/api/chemical/vendors/summary');
    return response.data;
  },
  getVendorById: async (id) => {
    const response = await api.get(`/api/chemical/vendors/${id}`);
    return response.data;
  },
  createVendor: async (data) => {
    const response = await api.post('/api/chemical/vendors', data);
    return response.data;
  },
  updateVendor: async (id, data) => {
    const response = await api.put(`/api/chemical/vendors/${id}`, data);
    return response.data;
  },
  deleteVendor: async (id) => {
    const response = await api.delete(`/api/chemical/vendors/${id}`);
    return response.data;
  },

  // ─── Batches ───────────────────────────────────────────────
  getBatches: async (params = {}) => {
    const response = await api.get('/api/chemical/batches', { params });
    return response.data;
  },
  getBatchesSummary: async () => {
    const response = await api.get('/api/chemical/batches/summary');
    return response.data;
  },
  getBatchesAlerts: async () => {
    const response = await api.get('/api/chemical/batches/alerts');
    return response.data;
  },
  getBatchesByProduct: async (productId) => {
    const response = await api.get(`/api/chemical/batches/by-product/${productId}`);
    return response.data;
  },
  getBatchById: async (id) => {
    const response = await api.get(`/api/chemical/batches/${id}`);
    return response.data;
  },
  createBatch: async (data) => {
    const response = await api.post('/api/chemical/batches', data);
    return response.data;
  },
  updateBatch: async (id, data) => {
    const response = await api.put(`/api/chemical/batches/${id}`, data);
    return response.data;
  },
  deleteBatch: async (id) => {
    const response = await api.delete(`/api/chemical/batches/${id}`);
    return response.data;
  },

  // ─── Formulas ──────────────────────────────────────────────
  getFormulas: async (params = {}) => {
    const response = await api.get('/api/chemical/formulas', { params });
    return response.data;
  },
  getFormulasSummary: async () => {
    const response = await api.get('/api/chemical/formulas/summary');
    return response.data;
  },
  getFormulaById: async (id) => {
    const response = await api.get(`/api/chemical/formulas/${id}`);
    return response.data;
  },
  createFormula: async (data) => {
    const response = await api.post('/api/chemical/formulas', data);
    return response.data;
  },
  updateFormula: async (id, data) => {
    const response = await api.put(`/api/chemical/formulas/${id}`, data);
    return response.data;
  },
  deleteFormula: async (id) => {
    const response = await api.delete(`/api/chemical/formulas/${id}`);
    return response.data;
  },

  // ─── Productions ───────────────────────────────────────────
  getProductions: async (params = {}) => {
    const response = await api.get('/api/chemical/productions', { params });
    return response.data;
  },
  getProductionsSummary: async () => {
    const response = await api.get('/api/chemical/productions/summary');
    return response.data;
  },
  getProductionById: async (id) => {
    const response = await api.get(`/api/chemical/productions/${id}`);
    return response.data;
  },
  createProduction: async (data) => {
    const response = await api.post('/api/chemical/productions', data);
    return response.data;
  },
  deleteProduction: async (id) => {
    const response = await api.delete(`/api/chemical/productions/${id}`);
    return response.data;
  },

  // ─── Purchases ─────────────────────────────────────────────
  getPurchases: async (params = {}) => {
    const response = await api.get('/api/chemical/purchases', { params });
    return response.data;
  },
  getPurchasesSummary: async () => {
    const response = await api.get('/api/chemical/purchases/summary');
    return response.data;
  },
  getPurchaseById: async (id) => {
    const response = await api.get(`/api/chemical/purchases/${id}`);
    return response.data;
  },
  createPurchase: async (data) => {
    const response = await api.post('/api/chemical/purchases', data);
    return response.data;
  },
  deletePurchase: async (id) => {
    const response = await api.delete(`/api/chemical/purchases/${id}`);
    return response.data;
  },
  createInward: async (data) => {
    const response = await api.post('/api/chemical/purchases/inward', data);
    return response.data;
  },

  // ─── Purchase Orders ───────────────────────────────────────
  getPurchaseOrders: async (params = {}) => {
    const response = await api.get('/api/chemical/purchase-orders', { params });
    return response.data;
  },
  getPurchaseOrdersSummary: async () => {
    const response = await api.get('/api/chemical/purchase-orders/summary');
    return response.data;
  },
  getPurchaseOrderById: async (id) => {
    const response = await api.get(`/api/chemical/purchase-orders/${id}`);
    return response.data;
  },
  createPurchaseOrder: async (data) => {
    const response = await api.post('/api/chemical/purchase-orders', data);
    return response.data;
  },
  deletePurchaseOrder: async (id) => {
    const response = await api.delete(`/api/chemical/purchase-orders/${id}`);
    return response.data;
  },

  // ─── Sales ─────────────────────────────────────────────────
  getSales: async (params = {}) => {
    const response = await api.get('/api/chemical/sales', { params });
    return response.data;
  },
  getSalesSummary: async () => {
    const response = await api.get('/api/chemical/sales/summary');
    return response.data;
  },
  getSaleById: async (id) => {
    const response = await api.get(`/api/chemical/sales/${id}`);
    return response.data;
  },
  createSale: async (data) => {
    const response = await api.post('/api/chemical/sales', data);
    return response.data;
  },
  deleteSale: async (id) => {
    const response = await api.delete(`/api/chemical/sales/${id}`);
    return response.data;
  },

  // ─── Gate Passes ───────────────────────────────────────────
  getGatePasses: async (params = {}) => {
    const response = await api.get('/api/chemical/gate-passes', { params });
    return response.data;
  },
  getGatePassesSummary: async () => {
    const response = await api.get('/api/chemical/gate-passes/summary');
    return response.data;
  },
  getGatePassById: async (id) => {
    const response = await api.get(`/api/chemical/gate-passes/${id}`);
    return response.data;
  },
  createGatePass: async (data) => {
    const response = await api.post('/api/chemical/gate-passes', data);
    return response.data;
  },
  updateGatePass: async (id, data) => {
    const response = await api.put(`/api/chemical/gate-passes/${id}`, data);
    return response.data;
  },
  updateGatePassStatus: async (id, status) => {
    const response = await api.patch(`/api/chemical/gate-passes/${id}/status`, { status });
    return response.data;
  },
  deleteGatePass: async (id) => {
    const response = await api.delete(`/api/chemical/gate-passes/${id}`);
    return response.data;
  },

  // ─── Payments ──────────────────────────────────────────────
  getPayments: async (params = {}) => {
    const response = await api.get('/api/chemical/payments', { params });
    return response.data;
  },
  getPaymentsSummary: async () => {
    const response = await api.get('/api/chemical/payments/summary');
    return response.data;
  },
  createPayment: async (data) => {
    const response = await api.post('/api/chemical/payments', data);
    return response.data;
  },
  deletePayment: async (id) => {
    const response = await api.delete(`/api/chemical/payments/${id}`);
    return response.data;
  },

  // ─── Expense Types ─────────────────────────────────────────
  getExpenseTypes: async (params = {}) => {
    const response = await api.get('/api/chemical/expense-types', { params });
    return response.data;
  },
  getExpenseTypeById: async (id) => {
    const response = await api.get(`/api/chemical/expense-types/${id}`);
    return response.data;
  },
  createExpenseType: async (data) => {
    const response = await api.post('/api/chemical/expense-types', data);
    return response.data;
  },
  updateExpenseType: async (id, data) => {
    const response = await api.put(`/api/chemical/expense-types/${id}`, data);
    return response.data;
  },
  deleteExpenseType: async (id) => {
    const response = await api.delete(`/api/chemical/expense-types/${id}`);
    return response.data;
  },
  // ─── Reports ───────────────────────────────────────────────
  getSalesReport: async (params = {}) => {
    const response = await api.get('/api/chemical/reports/sales', { params });
    return response.data;
  },
  getPurchaseReport: async (params = {}) => {
    const response = await api.get('/api/chemical/reports/purchase', { params });
    return response.data;
  },
  getStockReport: async (params = {}) => {
    const response = await api.get('/api/chemical/reports/stock', { params });
    return response.data;
  },
  getProductionReport: async (params = {}) => {
    const response = await api.get('/api/chemical/reports/production', { params });
    return response.data;
  },
  getLedgerReport: async (params = {}) => {
    const response = await api.get('/api/chemical/reports/ledger', { params });
    return response.data;
  },
  getProfitLossReport: async (params = {}) => {
    const response = await api.get('/api/chemical/reports/profit-loss', { params });
    return response.data;
  },

  // ─── Expenses ──────────────────────────────────────────────
  getExpenses: async (params = {}) => {
    const response = await api.get('/api/chemical/expenses', { params });
    return response.data;
  },
  getExpensesSummary: async () => {
    const response = await api.get('/api/chemical/expenses/summary');
    return response.data;
  },
  getExpenseById: async (id) => {
    const response = await api.get(`/api/chemical/expenses/${id}`);
    return response.data;
  },
  createExpense: async (data) => {
    const response = await api.post('/api/chemical/expenses', data);
    return response.data;
  },
  updateExpense: async (id, data) => {
    const response = await api.put(`/api/chemical/expenses/${id}`, data);
    return response.data;
  },
  deleteExpense: async (id) => {
    const response = await api.delete(`/api/chemical/expenses/${id}`);
    return response.data;
  },
};

export default chemicalService;